import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { VehicleRequestEntity } from "./vehicle-req-entity";
import { InjectRepository } from "@nestjs/typeorm";
import { EmployeeEntity } from "../employee/employee.entity";
import { DepartmentEntity } from "../department/department.entity";
import {
  VehicleIdReq,
  VehicleRequest,
  roleReq,
  vehicleReportReq,
} from "@project-management-system/shared-models";
import { VehicleEntity } from "../vehicle/vehicle.entity";
import { DriverEntity } from "../drivers/driver-entity";
import { LocationEntity } from "../location/location.entity";
import { LocationsEntity } from "../locations/locations.entity";
import { VendorEntity } from "../vendor/vendor.entity";
import { VehicleCategoryEntity } from "../vehicle-category/vehicle-category.entity";
import { VehicleTypeReq } from "../vehicle/vehicle-type.req";
import { PlantsEntity } from "../plants/plants.entity";
import { EmployyeHodMapping } from "../employee-hod-mapping/employee-mapping-entity";

@Injectable()
export class VehicleReqRepo extends Repository<VehicleRequestEntity> {
  constructor(
    @InjectRepository(VehicleRequestEntity)
    private repo: Repository<VehicleRequestEntity>
  ) {
    super(repo.target, repo.manager, repo.queryRunner);
  }
  async getAllDeptWiseVehicleData(req: roleReq): Promise<any[]> {
    const query = this.createQueryBuilder("v")
      .select(
          `v.vehicle_req_code as vehicleReqCode,v.hod_approval_date AS hodApprovalDate,
            v.vehicle_type AS vehicleType,
             v.requested_for As requestFor, 
            v.vehicle_purpose as vehiclePurpose ,
            v.pick_up_time as pickUpTime,
            v.admin_approval_date AS adminApprovalDate, 
            v.vehicle_type AS vehicleType,
            v.vehicle_id AS vehicleId,
            v.vendor_id AS vendorId, 
            v.cost,
            v.distance,
            v.status, 
            v.id as vehicleReqId,
            v.created_at as createdAt,
             v.opening_kms AS openingKms, 
            v.closing_kms AS closingKms,
            v.total_kms AS totalKms,
            v.extra_hrs AS extraHours,
            v.extra_kms AS extraKms,
            v.bata,
            v.toll_charges AS tollCharges,
            v.total_amount AS totalAmount,
            v.on_duty_time AS onDutyTime,
            v.off_duty_time AS offDutyTime,
            v.type,
            d.department_name AS departmentName,
            e.address As address,
            e.gps_location As gpslocation,
            e.code As code,
            e.access_no As accessNo,
            e.reporting_head_email_id As reportingHeadEmail,
            e.factory_code As factoryCode,
            e.employee_name AS employeeName,
            v.department_id,v.source,
            sl.location_name AS source,
            dl.location_name AS destination,
            v.no_of_people AS noOfPeople,
            v.vehicle_required_on AS vehicleRequiredOn,
            v.status `
      )
      .leftJoin(EmployeeEntity, `e`, `e.id=v.employee_id`)
      .leftJoin(DepartmentEntity, `d`, `d.id = v.department_id`)
      .leftJoin(LocationsEntity, `sl`, `sl.id=v.source`)
      .leftJoin(LocationsEntity, `dl`, `dl.id=v.destination`)
      .leftJoin(EmployyeHodMapping,`ehm`,`ehm.employee_id = v.employee_id`)
      .leftJoin(EmployeeEntity, `ep`, `ep.id=ehm.hod_id`)
      .where(`v.plant_id =`+req.plant)
      .andWhere(`ep.employee_code = '`+req.externalRefNo+`'`)
    if (req.vehicleReqCode !== undefined) {
      query.andWhere(`vehicle_req_code= '${req.vehicleReqCode}'`);
    }
    if (req.vehicleRequiredOn !== undefined) {
      query.andWhere(`vehicle_required_on= '${req.vehicleRequiredOn}'`);
    }
    query.orderBy("v.vehicle_required_on", "DESC").addOrderBy("v.created_at", "DESC");
    // if(req.role){
    //     query.where(`e.refNo ='`+req.externalRefNo+`'`)
    // }
    const result = await query.getRawMany();
    return result;
  }

  async getAdminApproval(req: VehicleRequest): Promise<any[]> {
    const query = this.createQueryBuilder("vr")
      .select(
        `vr.vehicle_req_code as vehicleReqCode,
          vr.requested_for As requestFor, 
          vr.id,vr.employee_id AS employeeId,
          vr.source,
          vr.destination,  
          vr.no_of_people AS noOfPeople,
          vr.vehicle_required_on AS vehicleRequiredOn,
          vr.pick_up_time As pickUpTime,
          vr.hod_approval_date AS hodApprovalDate,
          vr.admin_approval_date AS adminApprovalDate, 
          vr.vehicle_type AS vehicleType,
          vr.vehicle_id AS vehicleId,
          vr.vendor_id AS vendorId,
          vr.cost,
          vr.distance,
          vr.vehicle_purpose as vehiclePurpose ,
          vr.created_at AS createdAt,
          vr.status,
          e.employee_name AS employeeName,
          e.contact_number AS number,
          e.address As address,
          e.gps_location As gpslocation,
          e.code As code,
          e.access_no As accessNo,
          e.reporting_head_email_id As reportingHeadEmail,
          e.factory_code As factoryCode,
          d.department_name AS departmentName,
          vr.type AS routeType , 
          v.vehicle_name AS vehicle, 
          dr.name AS driver,
          vd.vendor_name AS vendor`
      )
      .leftJoin(EmployeeEntity, "e", `e.id=vr.employee_id`)
      .leftJoin(DepartmentEntity, `d`, `d.id = vr.department_id`)
      .leftJoin(LocationsEntity, `sl`, `sl.id=vr.source `)
      .leftJoin(LocationsEntity, `dl`, `dl.id=vr.destination`)
      .leftJoin(VehicleEntity, `v`, `v.id=vr.vehicle_id`)
      .leftJoin(DriverEntity, `dr`, `dr.id=vr.driver_id`)
      .leftJoin(VendorEntity, `vd`, `vd.id=vr.vendor_id`)
      .where(
        `vr.status  IN ("HOD APPROVAL PENDING","ADMIN APPROVAL PENDING","VEHICLE ASSIGNED","WAITING ON VENDOR", "TRIP STARTED","TRIP COMPLETED","REJECTED")`
      )
      .orderBy("vr.vehicle_required_on", "DESC")
      .addOrderBy("vr.created_at", "DESC");

    if (req.vehicleReqCode !== undefined) {
      query.andWhere(`vehicle_req_code= '${req.vehicleReqCode}'`);
    }
    if (req.vehicleRequiredOn !== undefined) {
      query.andWhere(`vehicle_required_on= '${req.vehicleRequiredOn}'`);
    }
    const result = await query.getRawMany();
    return result;
  }

  async getVehicleReqReportData(req: vehicleReportReq): Promise<any[]> {
    const query = this.createQueryBuilder("vr")
      .select(
        `vr.id, vr.vehicle_req_code as vehiclerequest, vr.source as 'to', vr.destination as 'from', d.department_name as department,d.id AS departmentId, d.hod, vr.created_at as raisedDate, vr.cost as approxcost, vr.distance as kms, vr.admin_approval_date as requestDate, e.employee_name as employee, vr.status`
      )
      .leftJoin(DepartmentEntity, `d`, `d.id = vr.department_id`)
      .leftJoin(EmployeeEntity, "e", `e.id=vr.employee_id`)
      .orderBy(`vr.status`);

    if (req.raisedDate !== undefined) {
      query.andWhere("vr.created_at LIKE :raisedDate", {
        raisedDate: `%${req.raisedDate}%`,
      });
    }
    if (req.requestDate !== undefined) {
      query.andWhere(`vr.admin_approval_date = "${req.requestDate}"`);
    }
    if (req.department !== undefined) {
      query.andWhere(`d.department_name = '${req.department}'`);
    }
    if (req.status !== undefined) {
      query.andWhere(`vr.status = "${req.status}"`);
    }
    return await query.getRawMany();
  }

  async getAllVehiclerequest(req?: VehicleRequest): Promise<any[]> {
    // console.log(req.extNo["roles"]);
    let query = this.createQueryBuilder("vr")
      .select(
        ` vr.vehicle_req_code AS vehicleReqCode,
            vr.requested_for As requestFor, 
            vr.id,
            vr.employee_id AS employeeId,
            vr.no_of_people AS noOfPeople,
            vr.vehicle_required_on AS vehicleRequiredOn, 
            vr.hod_approval_date AS hodApprovalDate,
            vr.admin_approval_date AS adminApprovalDate, 
            vr.vehicle_type AS vehicleType,
            vr.vehicle_id AS vehicleId,
            vr.vendor_id AS vendorId, 
            vr.cost,
            vr.distance,
            vr.status, 
            vr.pick_up_time as pickUpTime,
            vr.vehicle_purpose as vehiclePurpose,
            e.employee_name AS employeeName,
            e.contact_number AS number,
            e.address As address,
            e.gps_location As gpslocation,
            e.code As code,
            e.access_no As accessNo,
            e.reporting_head_email_id As reportingHeadEmail,
            e.factory_code As factoryCode,
            d.department_name AS departmentName,
            vr.opening_kms AS openingKms, 
            vr.closing_kms AS closingKms,
            vr.total_kms AS totalKms,
            vr.extra_hrs AS extraHours,
            vr.extra_kms AS extraKms,
            vr.bata,
            vr.toll_charges AS tollCharges,
            vr.total_amount AS totalAmount,
            vr.on_duty_time AS onDutyTime,
            vr.off_duty_time AS offDutyTime,
            vr.type,
            vr.is_active AS isActive,
            vr.created_user AS createdUser,
            vr.created_at AS createdAt,
            vr.updated_user AS updatedUser,
            vr.version_flag AS versionFlag,
            vr.source,
            vr.destination,
            vc.vehicle_category AS vehicleCategory,
            vr.vehicle_preference as vehiclePreference,p.plant_id AS plantId,p.plant_name AS plantName`
      )
      .leftJoin(DepartmentEntity, `d`, `d.id = vr.department_id`)
      .leftJoin(EmployeeEntity, "e", `e.id=vr.employee_id`)
      .leftJoin(LocationsEntity, "sl", `sl.id=vr.source`)
      .leftJoin(LocationsEntity, "dl", `dl.id=vr.destination`)
      .leftJoin(VehicleCategoryEntity,"vc",`vc.id=vr.vehicle_preference`)
      .leftJoin(PlantsEntity,"p",`p.plant_id=vr.plant_id`)
      if(req.extNo["unit"] != undefined){
        query = query.where(`p.plant_name = '${req.extNo["unit"]}'`)
      }
      if(req.extNo["roles"] != "VrsAdmin" && req.extNo["externalRefNo"] !== undefined){
        query = query.andWhere(`e.employee_code = ${req.extNo["externalRefNo"]}`)
      }
    if (req.vehicleReqCode !== undefined) {
      query.andWhere(`vehicle_req_code= '${req.vehicleReqCode}'`);
    }
    if (req.vehicleRequiredOn !== undefined) {
      query.andWhere(`vehicle_required_on= '${req.vehicleRequiredOn}'`);
    }
  
    query = query.orderBy("vr.vehicle_required_on", "DESC")
    .addOrderBy("vr.created_at", "DESC");
    return await query.getRawMany();
  }

  async getvehicledropdown(req?: VehicleRequest): Promise<any[]> {
    const query = this.createQueryBuilder("vr")
      .select(`
        vr.vehicle_req_code AS vehicleReqCode,
        vr.employee_id AS employeeId,
        vr.vehicle_required_on AS vehicleRequiredOn,
        d.department_name AS departmentName,
        e.employee_name AS employeeName,
        sl.location_name AS sourceLocation,
        dl.location_name AS destinationLocation
      `)
      .leftJoin(DepartmentEntity, "d", "d.id = vr.department_id")
      .leftJoin(EmployeeEntity, "e", "e.id = vr.employee_id")
      .leftJoin(LocationsEntity, "sl", "sl.id = vr.source")
      .leftJoin(LocationsEntity, "dl", "dl.id = vr.destination")
      .orderBy("vr.vehicle_req_code", "ASC")
      // .addOrderBy("vr.vehicle_req_code", "DESC");
  
    if (req) {
      if (req.vehicleReqCode !== undefined) {
        query.andWhere("vr.vehicle_req_code = :vehicleReqCode", { vehicleReqCode: req.vehicleReqCode });
      }
      if (req.vehicleRequiredOn !== undefined) {
        query.andWhere("vr.vehicle_required_on = :vehicleRequiredOn", { vehicleRequiredOn: req.vehicleRequiredOn });
      }
    }
  
    return await query.getRawMany();
  }
  
  
  async getAdmindropdown(req?: VehicleRequest): Promise<any[]> {
    const query = this.createQueryBuilder("vr")
      .select(`vr.id,vr.vehicle_req_code AS vehicleReqCode, vr.employee_id AS employeeId, vr.vehicle_required_on AS vehicleRequiredOn`)
      .leftJoin(EmployeeEntity, "e", "e.id = vr.employee_id")
      .leftJoin(DepartmentEntity, "d", "d.id = vr.department_id")
      .leftJoin(LocationsEntity, "sl", "sl.id = vr.source")
      .leftJoin(LocationsEntity, "dl", "dl.id = vr.destination")
      .leftJoin(VehicleEntity, "v", "v.id = vr.vehicle_id")
      .leftJoin(DriverEntity, "dr", "dr.id = vr.driver_id")
      .leftJoin(VendorEntity, "vd", "vd.id = vr.vendor_id")
      .where(`vr.status IN ("HOD APPROVAL PENDING","ADMIN APPROVAL PENDING", "VEHICLE ASSIGNED", "WAITING ON VENDOR")`)
      .orderBy("vr.vehicle_required_on", "DESC")
      .addOrderBy("vr.created_at", "DESC");
  
    if (req) {
      if (req.vehicleReqCode !== undefined) {
        query.andWhere("vr.vehicle_req_code = :vehicleReqCode", { vehicleReqCode: req.vehicleReqCode });
      }
      if (req.vehicleRequiredOn !== undefined) {
        query.andWhere("vr.vehicle_required_on = :vehicleRequiredOn", { vehicleRequiredOn: req.vehicleRequiredOn });
      }
    }
  
    return await query.getRawMany();
  }
  
  
  async getHoddropdown(req?: VehicleRequest): Promise<any[]> {
    const query = this.createQueryBuilder("v")
      .select(`v.vehicle_req_code AS vehicleReqCode, v.employee_id AS employeeId, v.vehicle_required_on AS vehicleRequiredOn`)
      .leftJoin(EmployeeEntity, `e`, `e.id=v.employee_id`)
      .leftJoin(DepartmentEntity, `d`, `d.id = v.department_id`)
      .leftJoin(EmployeeEntity, `ep`, `ep.id=d.hod_id`)
      .leftJoin(LocationsEntity, `sl`, `sl.id=v.source`)
      .leftJoin(LocationsEntity, `dl`, `dl.id=v.destination`)
      .orderBy("v.vehicle_required_on", "DESC")
      .addOrderBy("v.created_at", "DESC");
  
    if (req) {
      if (req.vehicleReqCode !== undefined) {
        query.andWhere("v.vehicle_req_code = :vehicleReqCode", { vehicleReqCode: req.vehicleReqCode });
      }
      if (req.vehicleRequiredOn !== undefined) {
        query.andWhere("v.vehicle_required_on = :vehicleRequiredOn", { vehicleRequiredOn: req.vehicleRequiredOn });
      }
    }
  
    return await query.getRawMany();
  }
  
  
  async getAssignedVehicleDetails(req:VehicleTypeReq): Promise<any[]> {
    // console.log("**************")
    // console.log(req)

    const query = this.createQueryBuilder("vr")
      .select(
        `vr.id,dr.name AS driver,v.vehicle_capacity AS capacity,vr.vehicle_required_on AS requestedDate,dl.location_name AS destination,e.employee_name AS employeeName,v.vehicle_name AS vehName,v.id AS vehicleId, vr.remarks, v.mark_model AS model`
      )
      .leftJoin(DepartmentEntity, `d`, `d.id = vr.department_id`)
      .leftJoin(EmployeeEntity, "e", `e.id=vr.employee_id`)
      .leftJoin(VehicleEntity, "v", `v.id=vr.vehicle_id`)
      .leftJoin(VehicleCategoryEntity, "vc", `vc.id=v.vehicle_category`)
      .leftJoin(DriverEntity, "dr", `dr.id=vr.driver_id`)
      .leftJoin(LocationsEntity, "dl", `dl.id=vr.destination`)
      .andWhere(`vr.status ='Vehicle Assigned'`)
      .andWhere(`vc.id =${req.categoryId}`)
      .andWhere(`v.vehicle_type = '${req.vehicleType}'`);
    return await query.getRawMany();
  }

  async getVehicleReportData(): Promise<any[]> {
    // sl.location_name AS pickUpPoint,dl.location_name AS dropUpPoint,

    const query = this.createQueryBuilder("vr")
      .select(
        `vr.vehicle_req_code AS trip, vr.created_at AS date,e.employee_name AS bookedBy,e.division AS division,d.department_name AS department,e.unit AS unit, et.employee_name AS approvedBy,no_of_people AS noOfPeople,sl.location_name AS source,dl.location_name AS destination,concat(v.vehicle_name,'-',v.registration_number) AS vehicleType, dr.name as driver, opening_kms AS openingKms, closing_kms As closingKms, total_kms AS totalKms, extra_hrs AS extraHrs, extra_kms AS extraKms, bata AS bata, toll_charges AS tollCharges,total_amount AS totalAmount,on_duty_time AS ondutyTime,off_duty_time AS offDutyTime,type AS type, cost AS cost, pick_up_time AS pickUpTime, vr.remarks,vr.requested_for AS requestedFor,vr.extra_hrs_charges AS extraHrsCharges, extra_kms_charges AS extraKmsCharges`
      )
      .leftJoin(EmployeeEntity, "e", `e.id=vr.employee_id`)
      .leftJoin(DepartmentEntity, "d", `d.id=e.department_name`)
      .leftJoin(EmployeeEntity, "et", `et.id=d.hod_id`)
      .leftJoin(VehicleEntity, "v", `v.id=vr.vehicle_id`)
      .leftJoin(DriverEntity, "dr", `dr.id=vr.driver_id`)
      .leftJoin(LocationsEntity, "sl", `sl.id=vr.source`)
      .leftJoin(LocationsEntity, "dl", `dl.id=vr.destination`);
    return await query.getRawMany();
  }
}
